/*
Model defined for Maintaining User Responses. It can also be used for transferring model
*/
export class SetPasswordModel {
    verificationType: string;
    verificationValue: string;
    newPassword: string;
    confirmPassword: string;
    email: string;
}



// WEBPACK FOOTER //
// ./src/app/_models/user/SetPasswordModel.ts